var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBCheckboxFill = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
  fill: "#E36D32"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.5735 7.38669C18.9563 7.76946 18.9563 8.39108 18.5735 8.77384L10.7344 16.613C10.3517 16.9957 9.73004 16.9957 9.34727 16.613L5.4277 12.6934C5.04493 12.3106 5.04493 11.689 5.4277 11.3063C5.81048 10.9235 6.43209 10.9235 6.81486 11.3063L10.0424 14.5307L17.1895 7.38669C17.5722 7.00392 18.1938 7.00392 18.5766 7.38669H18.5735Z",
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBCheckboxFill);
export { ForwardRef as ReactComponent };